module.exports = __webpack_public_path__ + "img/superkid-grad.2d9f398c.svg";